import React, { useEffect, useState } from "react";
import {
  Switch,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import "./TalentIntro.css";
import { useNavigate, useLocation } from "react-router-dom";
import Actors from "./assets/Actors.jpg";
import Models from "./assets/Models.jpg";
import Dancers from "./assets/Dancers.jpg";
import Singers from "./assets/Singers.jpg";
import VoiceOvers from "./assets/VoiceOvers.jpg";
import Fitness from "./assets/Fitness.jpg";
import LiveActs from "./assets/LiveActs.jpg";
import Youth from "./assets/Youth.jpg";
import TripleThreat from "./assets/TripleThreats.jpg";
import { Link } from "react-router-dom";
import CastingCategoriesTabs from "./components/CastingCategoriesTabs";
import Footer from "../components/NonLoggedFooter";
import SignUpForm from "./components/signUpForm";
import Navigation from "../RootNavigation";


    import NowCasting from "./components/NowCasting";

export default function TalentIntro() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  // determine initial state based on route
  const [isDirector, setIsDirector] = useState(false);
  const [categories, setCategories] = useState([]);
  const [showTalentGate, setShowTalentGate] = useState(false);
  const [openLoginDialog, setOpenLoginDialog] = useState(false);

  useEffect(() => {
    if (location.pathname === "/directorintro") {
      setIsDirector(true);
    } else {
      setIsDirector(false);
    }
  }, [location.pathname]);

  const handleToggle = (event) => {
    const checked = event.target.checked;
    setIsDirector(checked);

    if (checked) {
      navigate("/directorintro");
    } else {
      navigate("/talentintro");
    }
  };

  /* NAV SCROLL */
  useEffect(() => {
    const handleScroll = () => {
      const nav = document.getElementById("mainNav");
      nav?.classList.toggle("scrolled", window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* HAMBURGER BODY LOCK */
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "";
  }, [mobileOpen]);

  /* PARTNERS */
  useEffect(() => {
    const partners = [
      "NETFLIX",
      "UNIVERSAL",
      "DISNEY+",
      "HBO MAX",
      "HULU",
      "NBC",
      "SONY",
      "MARVEL",
      "AMC",
      "STARZ",
      "ABC",
      "LIONSGATE",
    ];
    const el = document.getElementById("partnersMarquee");
    if (!el) return;

    el.innerHTML = [...partners, ...partners]
      .map((p) => `<span class="partner-name">${p}</span>`)
      .join("");
  }, []);

  /* TABS */

  const talentData = [
    { title: "ACTORS", image: Actors },
    { title: "MODELS", image: Models },
    { title: "DANCERS", image: Dancers },
    { title: "SINGERS", image: Singers },
    { title: "VOICE-OVERS", image: VoiceOvers },
    { title: "FITNESS", image: Fitness },
    { title: "LIVE ACTS", image: LiveActs },
    { title: "YOUTH", image: Youth },
    { title: "TRIPLE THREAT", image: TripleThreat },
  ];
  const markets = [
    { city: "LOS ANGELES" },
    { city: "NEW YORK" },
    { city: "ATLANTA" },
    { city: "CHICAGO" },
    { city: "NEW ORLEANS" },
    { city: "MIAMI" },
    { city: "AUSTIN" },
    { city: "BOSTON" },
    { city: "PHILADELPHIA" },
    { city: "NATIONWIDE", icon: "🌎" },
  ];

  /* REVEAL */
  useEffect(() => {
    const els = document.querySelectorAll(
      ".reveal, .reveal-left, .reveal-right, .ds-reveal",
    );

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("visible");
        }
      });
    });

    els.forEach((el) => observer.observe(el));
  }, []);

  /* PROCESS HIGHLIGHT */
  useEffect(() => {
    const steps = document.querySelectorAll(".process-step");
    const nums = document.querySelectorAll(".process-big-num");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            const idx = [...steps].indexOf(e.target);
            nums.forEach((n, i) => n.classList.toggle("active-num", i === idx));
          }
        });
      },
      { threshold: 0.5 },
    );

    steps.forEach((s) => observer.observe(s));
  }, []);

  /* TALENT TILT */
  useEffect(() => {
    document.querySelectorAll(".talent-card-intro").forEach((card) => {
      card.onmousemove = (e) => {
        const r = card.getBoundingClientRect();
        const x = e.clientX - r.left;
        const y = e.clientY - r.top;

        const rx = ((r.width / 2 - x) / r.width) * -8;
        const ry = ((r.height / 2 - y) / r.height) * 8;

        card.style.transform = `perspective(800px) rotateX(${ry}deg) rotateY(${rx}deg) translateY(-8px)`;
      };
      card.onmouseleave = () => (card.style.transform = "");
    });
  }, []);

  return (
    <>
      {/* FILM GRAIN */}
      <div className="film-grain">
        <svg>
          <filter id="grain">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0.65"
              numOctaves="3"
            />
            <feColorMatrix type="saturate" values="0" />
          </filter>
          <rect width="100%" height="100%" filter="url(#grain)" />
        </svg>
      </div>

      {/* NAV */}
<Navigation />

      {/* HERO */}
      <section className="hero">
        <div className="curtain-left"></div>
        <div className="curtain-right"></div>
        <div className="spotlight"></div>

        <div className="hero-content">
          <div className="hero-toggle">
            <span
              className={!isDirector ? "active clickable" : "clickable"}
              onClick={() => {
                setIsDirector(false);
                navigate("/talentintro");
              }}
            >
              I AM TALENT
            </span>

            <Switch
              checked={isDirector}
              onChange={handleToggle}
              color="error"
              sx={{ transform: "scale(1.5)" }}
            />

            <span
              className={isDirector ? "active clickable" : "clickable"}
              onClick={() => {
                setIsDirector(true);
                navigate("/directorintro");
              }}
            >
              I’M A CASTING DIRECTOR
            </span>
          </div>
          {/*  <p className="hero-eyebrow">NYCastings / DirectSubmit</p>
           */}{" "}
          <h1 className="hero-headline">
            CAST SMARTER.
            <br /> <span className="red-word">CAST FASTER.</span>
          </h1>
          <p className="hero-sub">
            Post casting calls, review submissions, and connect directly with
            actors, models, singers, dancers, and voice-over talent nationwide.
          </p>
          <div className="hero-ctas">
            <Link to="/signup" className="hero-btn-primary">
              Create Casting Account
            </Link>

            <a href="/todays-casting-calls" className="hero-btn-secondary">
              See Today’s Casting Calls
            </a>
          </div>
          <div className="hero-stats">
            <div className="hero-stat">
              <div className="hero-stat-number">26+</div>
              <div className="hero-stat-label">Years Online</div>
            </div>
            <div className="hero-stat-divider"></div>
            <div className="hero-stat">
              <div className="hero-stat-number">120,000+</div>
              <div className="hero-stat-label">Projects Cast</div>
            </div>
            <div className="hero-stat-divider"></div>
            <div className="hero-stat">
              <div className="hero-stat-number">C2C</div>
              <div className="hero-stat-label"> Coast-to-Coast Casting</div>
            </div>
          </div>
        </div>
      </section>

      {/* PARTNERS MARQUEE */}
      <section className="partners-section">
        <div className="partners-label">Trusted Across the Industry</div>
        <div className="partners-marquee" id="partnersMarquee"></div>
      </section>

      {/*  OPEN ROLES */}
<NowCasting />

      {/*  TALENT TYPES */}
      <section className="talent-section">
        <div className="container">
          <h2 className="talent-title">Explore Talent</h2>
        </div>
        <div className="talent-scroll-wrapper">
          <div className="talent-cards">
            {talentData.map((item, index) => (
              <div
                key={index}
                className="talent-card-intro"
                style={{ backgroundImage: `url(${item.image})` }}
                onClick={() => setShowTalentGate(true)}
              >
                <div className="overlay"></div>
                <div className="title">{item.title}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="cta-section">
        <div className="cta-layout">
          <div className="cta-left reveal-left">
            <div className="cta-red-line"></div>

            <h2 className="cta-title">
              FIND
              <br />
              YOUR
              <br /> NEXT CAST
            </h2>
          </div>

       <div className="cta-right">
                <p className="cta-subtitle">
                  Join thousands of performers who have
                  <br />
                  launched their careers through DirectSubmit.
                </p>
    
<SignUpForm defaultAccountType={isDirector ? "creator" : "director"} />
                {/*   <div className="cta-buttons">
                   <Link to="/signup" className="hero-btn-primary">
      Create Free Profile
    </Link>
                </div> */}
              </div>
        </div>
      </section>

      {/*  FOOTER */}
           <Dialog
  open={openLoginDialog}
  onClose={() => setOpenLoginDialog(false)}
  PaperProps={{
    sx: {
      borderRadius: "18px",
      padding: "10px",
      textAlign: "center",
      background: "#111",
      color: "#fff",
      minWidth: "320px",
    },
  }}
>
  <DialogTitle
    sx={{
      fontWeight: 700,
      fontSize: "24px",
    }}
  >
    Login Required
  </DialogTitle>

  <DialogContent
    sx={{
      color: "#ccc",
      fontSize: "16px",
      mb: 1,
    }}
  >
    Login or create a casting account to view talent profiles.
  </DialogContent>

  <DialogActions
    sx={{
      display: "flex",
      justifyContent: "center",
      gap: 2,
      pb: 2,
    }}
  >
    <Button
      variant="outlined"
      onClick={() => navigate("/login")}
      sx={{
        borderColor: "#fff",
        color: "#fff",
        px: 3,
      }}
    >
      Login
    </Button>

    <Button
      variant="contained"
      onClick={() => navigate("/signup")}
      sx={{
        background: "#15d398",
        px: 3,
        "&:hover": {
          background: "#15d398",
        },
      }}
    >
      Create Account
    </Button>
  </DialogActions>
</Dialog>
<Footer />
      {showTalentGate && (
        <div
          className="talent-gate-overlay"
          onClick={() => setShowTalentGate(false)}
        >
          <div
            className="talent-gate-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Access Required</h3>
            <p>Log in or create a casting account to view our talent.</p>

            <div className="talent-gate-actions">
              <Link to="/login" className="btn-ghost">
                Log In
              </Link>
              <Link to="/signup" className="btn-primary">
                CREATE CASTING ACCOUNT
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
